import React from 'react';
import {Box, styled} from '@mui/material';
import {Headline, Icon} from '@lightricks/react-design-system';

const Container = styled(Box)(() => ({
  boxSizing: 'border-box',
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
  padding: '4px',
  height: '32px',
}));

function ReadyAssetsState({
  completed,
  total,
}: {
  completed: number;
  total: number;
}) {
  return (
    <Container>
      <Headline size="xs">
        {completed}/{total}
      </Headline>
      <Icon
        size="medium"
        appearance="neutral"
        name="Actions-Templates"
        style={{width: '20px', height: '20px'}}
      />
    </Container>
  );
}

export default ReadyAssetsState;
